class CopyTracking {
  private copyButtons: HTMLButtonElement[];

  constructor() {
    this.copyButtons = [...document.querySelectorAll<HTMLButtonElement>(".copy-tracking")];

    this.init();
  }

  private init() {
    this.copyButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const toCopy = btn.dataset.tracking;

        if (toCopy) {
          navigator.clipboard.writeText(toCopy);
        }
      });
    });
  }
}

export default CopyTracking;
